<form (ngSubmit)="onSubmit()" [formGroup]="form" class="form">
  <form-wrapper>
    <ng-container formArrayName="owners">
      <div class="row">
        @for (owner of owners.controls; track owner; let index = $index) {
          <ng-container [formGroup]="owner">
            <div class="col-md-{{ owners?.length > 1 ? 6 : 12 }}">
              <owner-header [owners]="owners" [index]="index"></owner-header>
              <ng-container formGroupName="esgProfil">
                <pr-input-radio
                  formControlName="includeESG"
                  columns="3"
                  [toggle]="true"
                  [isDefault]="false"
                  label=""
                >
                </pr-input-radio>
              </ng-container>
            </div>
          </ng-container>
        }
      </div>
      <div class="row">
        <div class="col-md-12">
          <info [option]="{ icon: 'info' }"
            >Les critères ESG (Environnementaux, Sociaux et Gouvernance) sont
            des critères, autres que financiers, qui permettent d’évaluer la
            prise en compte du développement durable et des enjeux à long terme
            dans une stratégie d'investissement.</info
          >
        </div>
      </div>
    </ng-container>
  </form-wrapper>
  <form-footer (prev)="prev()" (next)="onSubmit()"></form-footer>
</form>
